import { useFormik } from 'formik'
import * as Yup from 'yup'
import { locale } from 'locale'
import { FormInput } from 'components'
import { simService } from 'api/services/sim'
import { useContext, useState } from 'react'
import { Button, Card, toast } from 'keep-react'
import { IdCheckResponseBody } from 'api/types/sim'
import { AuthContext } from 'contexts/AuthContext'

const validationSchemaStep1 = Yup.object().shape({
  POLICYHOLDERID: Yup.string()
    .required(locale.required)
    .matches(/^[0-9]{9}$/, locale.validation.digits9),
})

export const SimulatorsStep1 = ({
  setCurrentStep,
  setNif,
  setHolder,
}: {
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>
  setNif: React.Dispatch<React.SetStateAction<string>>
  setHolder: React.Dispatch<React.SetStateAction<any>>
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { currentBroker } = useContext(AuthContext)

  const before = `before:inline-block before:align-middle before:text-center before:text-lg before:w-8 before:h-8 before:leading-8 before:rounded-full before:mr-4 before:text-white ${currentBroker?.IsPrimePartner ? 'before:bg-prime' : 'before:bg-primary-600'} before:bg-primary-600`
  const formikStep1 = useFormik({
    initialValues: { POLICYHOLDERID: '' },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: validationSchemaStep1,
    onSubmit: async values => {
      setIsLoading(true)
      setNif(values.POLICYHOLDERID)

      if (!currentBroker) {
        toast.error('No broker selected')
        setIsLoading(false)
        return
      }

      try {
        const response = (await simService.idCheck({
          brokerNo: currentBroker.BrokerNo.toString(),
          nif: parseInt(values.POLICYHOLDERID, 10),
        })) as IdCheckResponseBody

        if (response.Status.OK) {
          setHolder(response.Policyholder)
          setCurrentStep(2)
        } else {
          toast.error(response.Status.Errors?.[0].ErrorText)
        }
      } catch (error) {
        toast.error('NIF Bloqueado. Por favor Contacte a Innovarisk.')
      } finally {
        setIsLoading(false)
      }
    },
  })

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 w-full">
        <Card className="w-full p-8">
          <h3
            className={`text-body-1 py-4 before:content-['1'] px-4 bg-metal-100 ${before}`}
          >
            Validação do cliente
          </h3>
          <form
            onSubmit={formikStep1.handleSubmit}
            className="flex justify-between items-end gap-2 pt-6"
          >
            <div className="w-2/3">
              <FormInput
                label="NIF"
                name="POLICYHOLDERID"
                formik={formikStep1}
                type="number"
              />
            </div>
            <div className="pt-4">
              <Button
                color="primary"
                variant="default"
                disabled={isLoading}
                type="submit"
                className={`h-11 ${currentBroker?.IsPrimePartner ? 'bg-prime hover:bg-black hover:text-white' : 'bg-primary-600'}`}
              >
                Continuar
              </Button>
            </div>
          </form>
        </Card>
        <Card className="w-full p-8">
          <h3 className="text-body-3 uppercase pb-4">
            assistente de preenchimento
          </h3>
          <p className="text-body-4 text-slate-600">
            Por favor insira o número de contribuinte do cliente para
            verificação prévia
          </p>
        </Card>
      </div>
    </>
  )
}
